// removed by extract-text-webpack-plugin
module.exports = {"form__control-label":"formularioUsuario__form__control-label___3gYmq","form__footer":"formularioUsuario__form__footer___3iuIH","form__message-error":"formularioUsuario__form__message-error___3vAYi","form__field--error":"formularioUsuario__form__field--error___TZGSz","telefonos":"formularioUsuario__telefonos___XzGMp"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/registro-operador/formularioUsuario.css
// module id = 1183
// module chunks = 0